import axios from 'axios'
import requests from '@/services/api/api'

const sendNewOffer = async function(payload) {
    try {
        let response = await axios.post(requests.MASSIVE_CREATE_SL_OFFERS, {
            wh_products: payload.whProducts,
            name: payload.offerName,
            g_branch_office_id: payload.branchOffice,
            init_datetime: payload.initOffer,
            finish_datetime: payload.finishOffer,
        })

        return response
    } catch (error) {
        let response = {
            status: 500, // error response from server
        }

        return response
    }
}

const sendDeleteOffers = async function(payload) {
    try {
        // Soft delete
        let response = await axios.patch(
            requests.MASSIVE_DELETE_SL_OFFERS,
            payload
        )

        return response
    } catch (error) {
        let response = 'Ha ocurrido un error con la conexión al servidor'

        return response
    }
}

const deleteMassiveItems = async function(data) {
    try {
        let response = await axios.patch(
            process.env.VUE_APP_API_ROUTE + `/massive_delete_offer`,
            data
        )
        return response
    } catch (error) {
        return error.response.data
    }
}

export default {
    sendNewOffer,
    sendDeleteOffers,
    deleteMassiveItems,
}
